module.exports = __webpack_public_path__ + "img/_DSC0508.e16c4c41.jpg";